"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEventMapRequest = fetchEventMapRequest;
exports.fetchEventsRequest = fetchEventsRequest;
exports.fetchEventGroupRequest = fetchEventGroupRequest;
const api_1 = require("../utils/api");
const utils_1 = require("./utils");
async function fetchEventMapRequest({ org, mod, patientId, queries, internal }) {
    const groups = (0, utils_1.groupQueries)(queries);
    const requests = groups.map(queries => fetchEventGroupRequest({ org, mod, patientId, queries, internal }));
    const items = (await Promise.all(requests)).flat();
    const map = {};
    for (const item of items) {
        map[(0, utils_1.mapQueryToString)(item.query)] = item;
    }
    return map;
}
async function fetchEventsRequest({ org, mod, patientId, query }) {
    const url = getEventUrl({ patientId, queries: [query], org, mod });
    const { data } = await (0, api_1.fetchWithRetries)(url, 0);
    return data || [];
}
async function fetchEventGroupRequest({ org, mod, patientId, queries, internal }) {
    const url = getEventUrl({ patientId, queries, org, mod, internal });
    const { data: events } = await (0, api_1.fetchWithRetries)(url, 0);
    return queries.map(query => ({
        query,
        events: (events ?? []).filter(event => (0, utils_1.isEventOfQuery)(query, event))
    }));
}
function getEventUrl({ org, mod, patientId, queries, internal }) {
    const { limit: n = 1 } = queries[0];
    let base;
    const params = [];
    if (n === Infinity) {
        base = internal
            ? `/events/internal/${patientId}`
            : `/events/${patientId}`;
    }
    else {
        base = internal
            ? `/events/internal/${patientId}/last`
            : `/events/${patientId}/last`;
        params.push(`n=${n}`);
    }
    params.push(`organization=${org}`);
    params.push(`module=${mod}`);
    for (const query of queries) {
        params.push(`i=${(0, utils_1.mapQueryToString)(query)}`);
    }
    return `${base}?${params.join("&")}`;
}
